//frontend\src\lib\api.js
import axios from "axios";
import { tenantHeaders } from "./tenant.js";

const BASE = (import.meta.env.VITE_API_URL || "").replace(/\/+$/, "");

// Si BASE termina en /api -> no agregamos prefijo
// Si BASE NO termina en /api -> usamos /api
export const API_PREFIX = BASE.endsWith("/api") ? "" : "/api";

// opcional, pero recomendado: exportar un cliente axios único
export const api = axios.create({
  baseURL: BASE,
  withCredentials: true,
});

api.interceptors.request.use((config) => {
  const headers = tenantHeaders();
  config.headers = config.headers || {};
  config.headers["x-tenant"] = config.headers["x-tenant"] || headers["x-tenant"];
  config.headers["x-tenant-slug"] = config.headers["x-tenant-slug"] || headers["x-tenant-slug"];
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = Number(error?.response?.status || 0);
    const code = String(error?.response?.data?.code || "").toUpperCase();
    const requestUrl = String(error?.config?.url || "");
    const isLoginRequest = requestUrl.includes("/auth/login");

    if (
      typeof window !== "undefined" &&
      !isLoginRequest &&
      status === 401 &&
      ["AUTH_REQUIRED", "SESSION_INVALID"].includes(code)
    ) {
      window.dispatchEvent(new Event("nexoprint:session-invalid"));
    }

    return Promise.reject(error);
  }
);
